// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OnboardingChecklist-module__Container__QnIIX {
    border-bottom-right-radius: var(--ds-l);
    border-bottom-left-radius: var(--ds-l);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `OnboardingChecklist-module__Container__QnIIX`
};
export default ___CSS_LOADER_EXPORT___;
